/**
 * This mixin handles determining if the user swiped left or swipes right for a given
 * container.  The component using this mixin needs to call "registerTouchContainer"
 * to initialize the listener.  The component also needs to implement "swipeLeft()"" and
 * "swipeRight()" methods that this mixin will call when they happen.
 */
const MIN_SWIPE_DISTANCE = 75

export default {
  data() {
    return {
      preventVertical: false,
      touchContainerEl: null,
      touchOffset: 0,
      touchStarted: false,
      touchStartX: 0,
      touchStartY: 0
    }
  },
  methods: {
    handleTouchstart(e) {
      this.touchStarted = true
      this.touchStartX = e.changedTouches[0].clientX
      this.touchStartY = e.changedTouches[0].clientY
    },
    handleTouchend(e) {
      this.touchOffsetX = (this.touchStartX - e.changedTouches[0].clientX)
      this.touchOffsetY = (this.touchStartY - e.changedTouches[0].clientY)
      if (Math.abs(this.touchOffsetY) > Math.abs(this.touchOffsetX)) {
        return
      }
      if (this.touchOffsetX > MIN_SWIPE_DISTANCE) {
        // this method should be implemented by the component using this mixin
        this.swipeLeft()
      } else if (this.touchOffsetX < -MIN_SWIPE_DISTANCE) {
        // this method should be implemented by the component using this mixin
        this.swipeRight()
      }
      this.touchStarted = false
      this.touchStartX = 0
    },
    handleTouchmove(e) {
      if (this.preventVertical) {
        e.preventDefault()
      }
    },
    // this should be called by the component using this mixin when the scrollable area is
    // mounted(visible)
    registerTouchContainer(containerEl) {
      if ('ontouchstart' in window) {
        this.touchContainerEl = containerEl
        this.touchContainerEl.addEventListener('touchstart', this.handleTouchstart)
        this.touchContainerEl.addEventListener('touchend', this.handleTouchend)
        this.touchContainerEl.addEventListener('touchmove', this.handleTouchmove)
      }
    }
  },
  beforeDestroy() {
    if ('ontouchstart' in window && this.touchContainerEl) {
      this.touchContainerEl.removeEventListener('touchstart', this.handleTouchstart)
      this.touchContainerEl.removeEventListener('touchend', this.handleTouchend)
      this.touchContainerEl.removeEventListener('touchmove', this.handleTouchmove)
    }
  }
}
